import { Button, Typography } from '@iheartjane/reefer';
import { useFormContext } from '@iheartjane/reefer-hook-form';

import { useKioskSpacing } from '@jane/kiosk/hooks';
import { SCREEN_NAMES, useCheckout } from '@jane/kiosk/providers';
import type { CheckoutFormFields } from '@jane/kiosk/providers';

import {
  MFAField,
  SubmitCustomerInfoButton,
} from '../CustomerInfoFields/CustomerInfoFields';
import { ButtonWrapper } from './checkout.styles';

export const MFAScreen = () => {
  const formMethods = useFormContext<CheckoutFormFields>();
  const { getKioskSpacing, isIpad, defaultSpacing } = useKioskSpacing();
  const {
    isOrderLoading,
    setScreen,
    userPhone,
    codeResent,
    resendCode,
    sendingCode,
    verifyCode,
    verifyingCode,
    errorSendingCode,
    errorVerifyingCode,
  } = useCheckout();

  return (
    <>
      <MFAField
        codeResent={codeResent}
        errorSendingCode={errorSendingCode}
        errorVerifyingCode={errorVerifyingCode}
        phoneNumber={userPhone}
        resendCode={resendCode}
        sendingCode={sendingCode}
      />
      <ButtonWrapper
        marginTop={defaultSpacing}
        gap={getKioskSpacing(24, 16)}
        isIpad={isIpad}
      >
        <Button
          label={
            isIpad ? (
              'Cancel'
            ) : (
              <Typography as="h3" variant="h4-semibold">
                Cancel
              </Typography>
            )
          }
          onClick={() => setScreen(SCREEN_NAMES.payment)}
          size={isIpad ? 'small' : 'large'}
          full
          variant="tertiary"
          disabled={isOrderLoading}
        />

        <SubmitCustomerInfoButton
          loading={verifyingCode}
          size={isIpad ? 'small' : 'large'}
          onClick={() => verifyCode(String(formMethods.getValues('code')))}
        />
      </ButtonWrapper>
    </>
  );
};
